import { z } from 'zod';

/** Referência de viajante {id,name} — id do business subgraph, name para display.
 *  Mesmo shape do NamedRef, nomeado à parte por semântica (viajante ≠ opção corp.). */
export const TravelerRefSchema = z.object({ id: z.string().min(1), name: z.string() });
export type TravelerRef = z.infer<typeof TravelerRefSchema>;
